(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Behavior', 'app/widget/modal/modalService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var modalService = require('./modalService');
    module.exports = factory(require('backbone-torso/modules/Behavior'), modalService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoBehavior, modalService) {
  'use strict';

  /**
   * Modal Behavior
   *
   * This behavior is for views that act as modals (such as confirmation dialogs and alert dialogs).
   * See also UseModalBehavior.js, a behavior for views that instantiate modals.
   *
   * If you've added this behavior to a view, you can use this.resolveModal or this.rejectModal to close
   * the modal.  Either can be passed a results object which will be passed along to the modal's promise.
   *
   * @class ModalBehavior
   */
  return TorsoBehavior.extend({

    mixin: {

      /**
       * Closes this modal, by telling the parent to resolve it.
       *
       * @method resolveModal
       * @param results {Object} the results with which to resolve the modal's deferred.
       */
      resolveModal: function(results) {
        this.view.trigger('modal:resolveModal', this.view, results);
      },

      /**
       * Closes this modal, by telling the parent to reject it.
       *
       * @method rejectModal
       * @param results {Object} the results with which to reject the modal's deferred
       */
      rejectModal: function(results) {
        this.view.trigger('modal:rejectModal', this.view, results);
      },

      /**
       * Check to see if this modal instance is already in the stack.
       * Returns true even if the modal is 'hidden'.
       * Named different from UseModalBehavior's isModalInStack method, in case a view uses both behaviors.
       *
       * @method isInStack
       * @returns {boolean} whether this modal is already in the stack
       */
      isInStack: function() {
        return modalService.isModalInStack(this.view);
      },

      /**
       * Check to see if this modal instance is the top-most active modal
       * in the stack (i.e. should be receiving input).
       * Named different from UseModalBehavior's isTopActiveModal method, in case a view uses both behaviors.
       *
       * @method isTopActive
       * @returns {boolean} whether this modal is the top-most active one
       */
      isTopActive: function() {
        return modalService.isTopActiveModal(this.view);
      }
    },

    /**
     * @method _detached
     * @override
     */
    _detached: function() {
      this._hideModal();
    },

    /**
     * @method _attached
     * @override
     */
    _attached: function() {
      this._reshowModal();
    },

    /**
     * @method _dispose
     * @override
     */
    _dispose: function() {
      this._cleanUpModal();
    },

    /**
     * Tells the parent to hide the modal.
     * This is for when a modal is detached by the view lifecycle.
     *
     * @method _hideModal
     * @private
     */
    _hideModal: function() {
      this.view.trigger('modal:hideModal', this.view);
    },

    /**
     * Tells the parent to re-show the modal.
     * This is for when a modal is re-attached by the view lifecycle.
     *
     * @method _reshowModal
     * @private
     */
    _reshowModal: function() {
      this.view.trigger('modal:reshowModal', this.view);
    },

    /**
     * Tells the parent to clean up the modal.
     * This is for when a modal is disposed by the view lifecycle/etc.
     *
     * @method _cleanUpModal
     * @private
     */
    _cleanUpModal: function() {
      this.view.trigger('modal:cleanUpModal', this.view);
    }

  });
}));
